// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1rw-3jshQzRSGMo2iLyrKA","li-filter":"_2TqPd8eIscn7ZQUJjpnfQ_","menu-title-loyalty-row":"_2LhSZrWLJ1RdEfdJGeusg2"};